/**
 * Scroll-view: translateX animation for .sv-from-left and .sv-from-right.
 * - In the top 25% of the viewport: element at rest (translateX 0).
 * - In the bottom 75%: animates from off-screen to rest as the user scrolls.
 */

(function () {
  const REST_ZONE = 0.45; // top 25% of viewport = resting position

  const fromLeftEls = document.querySelectorAll('.sv-from-left');
  const fromRightEls = document.querySelectorAll('.sv-from-right');
  const animatedEls = [...fromLeftEls, ...fromRightEls];

  if (animatedEls.length === 0) return;

  function getProgress(rect, vh) {
    const restY = vh * REST_ZONE;
    // Above rest zone → fully in place
    if (rect.top <= restY) return 1;
    // Below viewport → fully off (hasn't entered)
    if (rect.top >= vh) return 0;
    // Between: 0 when top at viewport bottom, 1 when top at rest line
    const range = vh - restY;
    return 1 - (rect.top - restY) / range;
  }

  function setTranslate(el, progress, fromRight) {
    const t = 1 - progress; // 0 at rest, 1 when off-screen
    const x = t * 100; // 100% of element width
    const value = fromRight ? `${x}%` : `${-x}%`;
    el.style.transform = `translateX(${value})`;
  }

  function getRectForProgress(el) {
    return el.classList.contains('sv-anchor-parent') && el.parentElement
      ? el.parentElement.getBoundingClientRect()
      : el.getBoundingClientRect();
  }

  function update() {
    const vh = window.innerHeight;

    fromLeftEls.forEach((el) => {
      const rect = getRectForProgress(el);
      const progress = getProgress(rect, vh);
      setTranslate(el, progress, false);
    });

    fromRightEls.forEach((el) => {
      const rect = getRectForProgress(el);
      const progress = getProgress(rect, vh);
      setTranslate(el, progress, true);
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

// Add scroll-view animation for .sv-fade-out (fade/scale out as element moves up in top half of viewport)
(() => {
  const fadeEls = Array.from(document.querySelectorAll('.sv-fade-out'));
  if (fadeEls.length === 0) return;

  function getFadeProgress(rect, vh) {
    // Fade out as the element moves up in the top half of the viewport
    const fadeStart = vh * 0.015;
    const fadeEnd = Math.min(vh * 0.3, 255);
    if (rect.bottom <= fadeStart) return 0; // fully out/faded out
    if (rect.top >= fadeEnd) return 1; // fully in/faded in
    // Interpolate in the region between top and halfway down
    const visible = (rect.bottom - fadeStart) / (fadeEnd - fadeStart);
    return Math.min(Math.max(visible, 0), 1);
  }

  function setFade(el, progress) {
    // progress: 0 = invisible/hidden, 1 = visible, scale in
    const minScale = 0.9;
    const scale = minScale + progress * (1 - minScale); // from minScale to 1
    el.style.opacity = progress;
    el.style.transform = `scale(${scale})`;
  }

  function updateFade() {
    const vh = window.innerHeight;
    fadeEls.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const progress = getFadeProgress(rect, vh);
      setFade(el, progress);
    });
  }

  window.addEventListener('scroll', updateFade, { passive: true });
  window.addEventListener('resize', updateFade);
  updateFade();
})();
